import styled from '@emotion/styled';
import { AggregatedReportBreakdownGroup } from '../../../../../../../types';
import { SubgroupAccordion } from './SubgroupAccordion';
import { RefObject } from 'react';

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

interface Props {
  subgroups: AggregatedReportBreakdownGroup[];
  tablesMap: Record<string, RefObject<HTMLDivElement>>;
  onHorizontalScroll: React.UIEventHandler<HTMLDivElement>;
  group: AggregatedReportBreakdownGroup;
}

export const Subgroups = ({ subgroups, tablesMap, group, onHorizontalScroll }: Props) => {
  return (
    <Wrapper>
      {subgroups.map((subgroup) => (
        <SubgroupAccordion
          onHorizontalScroll={onHorizontalScroll}
          tableRef={tablesMap[group.groupName + subgroup.groupName]}
          subgroup={subgroup}
          key={subgroup.groupName}
        />
      ))}
    </Wrapper>
  );
};
